// extracted by mini-css-extract-plugin
export default {"content":"Privacy_content__dNztQ","text":"Privacy_text__9scn6","buttons":"Privacy_buttons__bDxuc","placeHolderShimmer":"Privacy_placeHolderShimmer__VIziW"};